import { TicketSelectionValidationError } from '@vista/omnichannel-components-domain';
import { assertUnreachableHelper } from '../../../../utils/assertion-utils';
/**
 *  Map the error message provided via the API to the display text required by the Ticket Picker component.
 * @param ticketValidationResult
 * @param displayText
 */
export function mapTicketPickerErrorMessage(ticketValidationResult, displayText) {
    switch (ticketValidationResult) {
        case TicketSelectionValidationError.NoTicketsSelected:
            return displayText.errorNoTicketsSelectedMessage;
        case TicketSelectionValidationError.TooManyTickets:
            return displayText.errorTooManyTicketsSelectedMessage;
        case TicketSelectionValidationError.TooFewTickets:
            return displayText.errorTooFewTicketsSelectedMessage;
        case TicketSelectionValidationError.TicketsDoNotMatchSelectedSeats:
            return displayText.errorTicketsDoNotMatchAreaCategoriesMessage;
        default:
            return assertUnreachableHelper('Invalid Ticket validation result')(ticketValidationResult);
    }
}
